import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { get } from '@core/js/utils/fetch.util';

import { useDataFetchWithAwait } from '@interlayer/js/app/hooks/useDataFetchWithAwait';
import { useDynamicTags } from '@interlayer/js/app/hooks/useDynamicTags';
import { usePostCodeSelector } from '@interlayer/js/app/store/hooks/usePostCodeSelector';
import {
    setClubsList,
    setIsClubListLoaded
} from '@interlayer/js/app/store/reducers/postCodeFinder/actions';
import { TClubsListResponse } from '@interlayer/js/app/store/reducers/postCodeFinder/types';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';
import { parseQueryString } from '@interlayer/js/app/utils/parseQueryString.util';

export const useGetClubsList = () => {
    const dispatch = useDispatch();
    const { isClubListLoaded } = usePostCodeSelector();
    const [
        dTagClubsListUrl,
        dTagLocationListId,
        dTagClubsListAPIKey
    ] = useDynamicTags([
        DYNAMIC_TAG_NAMES.clubsListUrl,
        DYNAMIC_TAG_NAMES.locationListId,
        DYNAMIC_TAG_NAMES.clubsListAPIKey
    ]);

    const queryString = parseQueryString({
        Key: dTagClubsListAPIKey,
        listID: dTagLocationListId
    });

    const onResponse = (response: TClubsListResponse) => {
        if (response.Number) {
            dispatch(setIsClubListLoaded(true));

            return;
        }

        const clubsList = response.Locations.map(({ MetaInfo, ...rest }) => ({
            ...rest,
            BuzzId: MetaInfo.buzzid,
            BuzzPostcode: MetaInfo.buzzpostcode
        }));

        dispatch(setClubsList(clubsList));

        dispatch(setIsClubListLoaded(true));

        return clubsList;
    };

    const { fetch } = useDataFetchWithAwait({
        fetch: get,
        onResponse,
        shouldFetch: () => !isClubListLoaded
    });

    return useCallback(() => {
        return fetch({ paramsFetch: `${dTagClubsListUrl}?${queryString}` });
    }, [dTagClubsListUrl, fetch, queryString]);
};
